import type {
  LC_AttendanceConceptHandlingItem,
  AttendanceConceptHandling,
  LC_AttendanceConceptFormulaItem,
  AttendanceConceptFormula,
} from './attendanceConceptCatalog.types';


export function mapAttendanceConceptHandling(
  raw: LC_AttendanceConceptHandlingItem,
): AttendanceConceptHandling {
  return {
    id: raw.handlingId,
    name: raw.handlingName ?? '',
  };
}

export function mapAttendanceConceptFormula(
  raw: LC_AttendanceConceptFormulaItem,
): AttendanceConceptFormula {
  return {
    id: raw.formulaId,
    name: raw.formulaName ?? '',
  };
}
